export default __webpack_public_path__ + "static/akzo-nobel-933a3c550bc75b164695841fd66b7b2a.png";